<div class="row">
  <ng-container *ngIf="!loading && !individualAuctionItems.present.length">
    <div class="col-12">
      <p class="text-center pt-4 fs-medium">Oops! Auction not available.</p>
    </div>
  </ng-container>
  <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of individualAuctionItems.present">
    <app-auction-card [item]="item" [auctionType]="'current'"></app-auction-card>
  </div>
</div>

<app-loader *ngIf="loading"></app-loader>
